import { FC, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import CustomErrorBoundary from '../../components/LayoutWrapper/CustomErrorBoundary';
import { ThreeDotLoader } from '../../components/Fallback/ThreeDotsLoader';
import { DemoGuidedTourBanner } from './DemoGuidedTourBanner';
import { DemoSkillResource } from './DemoSkillResource';
import { useGuidedTourContent } from './useGuidedTourContent';
import { getSegmentBySlug } from './guidedTour';

const DemoSingleSkillPageInner: FC<{ skillCode: string }> = ({ skillCode }) => {
  const content = useGuidedTourContent(skillCode);
  return <DemoSkillResource content={content} />;
};

const GuidedTourErrorFallback: FC = () => (
  <div
    data-testid="guided-tour-error"
    className="tw-mx-4 tw-p-4 tw-border tw-border-red-300 tw-bg-red-50 tw-rounded tw-flex tw-items-center tw-justify-between"
  >
    <span>Couldn’t load the guided tour content.</span>
    <button
      type="button"
      onClick={() => window.location.reload()}
      className="tw-px-3 tw-py-1 tw-rounded tw-bg-white tw-border tw-border-red-300 tw-font-semibold tw-cursor-pointer"
    >
      Try again
    </button>
  </div>
);

export const DemoSingleSkillPage: FC = () => {
  const { skillCode: slug } = useParams();
  const segment = getSegmentBySlug(slug ?? '');
  return (
    <div data-testid="demo-single-skill-page" className="nc_page-inner xl:tw-w-10/12 tw-mx-auto tw-w-11/12">
      <h1 className="tw-sr-only">Guided tour — {segment.title}</h1>
      <DemoGuidedTourBanner />
      <CustomErrorBoundary fallback={<GuidedTourErrorFallback />}>
        <Suspense fallback={<ThreeDotLoader dark />}>
          <DemoSingleSkillPageInner skillCode={segment.skillCode} />
        </Suspense>
      </CustomErrorBoundary>
    </div>
  );
};
